import React from "react";
import Card from "react-bootstrap/Card";
import Detail from "./Detail";
import openPokeball from "./openpokeball.png";

const PokemonCard = (props) => {
  var typing = "";
  var sprite;
  var name;
  var height;
  var weight;

  if (props.pokemon !== undefined) {
    name =
      "#" +
      props.pokemon.order +
      " " +
      props.pokemon.name.replace(/^\w/, (c) => c.toUpperCase());
    height = props.pokemon.height / 10 + "m";
    weight = props.pokemon.weight / 10 + "kg";

    if (props.pokemon.types.length <= 1) {
      typing = (
        <div>
          {props.pokemon.types[0].type.name.replace(/^\w/, (c) =>
            c.toUpperCase()
          )}
        </div>
      );
    } else {
      typing = (
        <div>
          {props.pokemon.types[0].type.name.replace(/^\w/, (c) =>
            c.toUpperCase()
          ) +
            "/" +
            props.pokemon.types[1].type.name.replace(/^\w/, (c) =>
              c.toUpperCase()
            )}
        </div>
      );
    }
    sprite = props.pokemon.sprites.front_default;
  } else {
    sprite = openPokeball;
    name = "Error, Please Select Another Pokémon";
    typing = "???";
    height = "???";
    weight = "???";
  }

  return (
    <Card style={{ width: "18rem", margin: "auto" }}>
      <Card.Body>
        <Card.Img style={{ width: "auto" }} src={sprite} />
        <Card.Title>{name}</Card.Title>

        {typing}
        <Detail label="Height" value={height} />
        <Detail label="Weight" value={weight} />
      </Card.Body>
    </Card>
  );
};

export default PokemonCard;
